import { z } from 'zod';

export const AuiToken = z.enum(['asurion-light', 'asurion-dark', 'partner-light', 'partner-dark']);

export const AuiTokenSchema = z.object({
  auiToken: AuiToken,
});
